import { FetchAppInfoBridge } from "./BridgeMethods/FetchAppInfoBridge";
import { FetchTokenBridge } from "./BridgeMethods/FetchTokenBridge";
import { GenerateTokenBridge } from "./BridgeMethods/GenerateTokenBridge";
import { BRIDGE_METHODS } from "./bridgeConstants";

export const bridgeHandler = function (
  bridgeError,
  response,
  bridgeContext,
  bridgeBody
) {
  try {
    bridgeContext = atob(bridgeContext);
    bridgeBody = atob(bridgeBody);

    var context =
      typeof bridgeContext === "string"
        ? JSON.parse(bridgeContext)
        : bridgeContext;
    if (!context.bridgeType) {
      return;
    }

    var body =
      typeof bridgeBody === "string"
        ? JSON.parse(bridgeBody) || {}
        : bridgeBody;
    var error = bridgeError
      ? JSON.parse(bridgeError)
      : undefined;

    switch (context.bridgeType) {
      case BRIDGE_METHODS.FETCH_TOKEN:
        FetchTokenBridge(
          error,
          response,
          context,
          body.data
        );
        return;

      case BRIDGE_METHODS.GENERATE_TOKEN:
        GenerateTokenBridge(
          error,
          response,
          context,
          body.data
        );
        return;

      case BRIDGE_METHODS.FETCH_APP_INFO:
        FetchAppInfoBridge(
          error,
          response,
          context,
          body.data
        );
        return;
      default:
        return;
    }
  } catch (err) {
    console.log(err);
    return;
  }
};
